import { type UserResource } from '@/features/iam/api/resources/users'
import { type UserProps } from '@/features/iam/users/User'

export function mapUserResourceToProps(
  resource: UserResource,
): Partial<UserProps> {
  return {
    email: resource.email,
    id: resource.user_id,
    publicId: resource.public_id,
    authId: resource.auth_id,
    givenName: resource.given_name,
    familyName: resource.family_name,
    phone: resource.phone,
    picture: resource.picture,
    platformAdmin: resource.platform_admin,
  }
}
